import React, { useEffect } from 'react';
import { Container, Typography, Box, Tabs, Tab } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader';
import NotificationTestPanel from '../../components/admin/NotificationTestPanel';
import NotificationStats from '../../components/admin/NotificationStats';

/**
 * Page de gestion des notifications pour les administrateurs
 */
const NotificationManagement = () => {
    const [activeTab, setActiveTab] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();

    // Détecter le paramètre tab dans l'URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get('tab');

        if (tabParam) {
            const tabIndex = parseInt(tabParam);
            if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex <= 1) {
                setActiveTab(tabIndex);
            }
        }
    }, [location.search]);

    /**
     * Changer d'onglet
     */
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);

        // Mettre à jour l'URL avec le nouvel onglet
        if (newValue === 0) {
            navigate('/admin/notifications');
        } else {
            navigate(`/admin/notifications?tab=${newValue}`);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <PageHeader
                title="Gestion des notifications"
                subtitle="Envoyez et analysez les notifications système"
                icon={<NotificationsIcon />}
            />

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="notification management tabs"
                >
                    <Tab label="Envoyer des notifications" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Statistiques" id="tab-1" aria-controls="tabpanel-1" />
                </Tabs>
            </Box>

            <Box role="tabpanel" hidden={activeTab !== 0} id="tabpanel-0" aria-labelledby="tab-0">
                {activeTab === 0 && <NotificationTestPanel />}
            </Box>

            <Box role="tabpanel" hidden={activeTab !== 1} id="tabpanel-1" aria-labelledby="tab-1">
                {activeTab === 1 && <NotificationStats />}
            </Box>
        </Container>
    );
};

export default NotificationManagement;